export const SET_SIGNALR_CONNECTION = 'setSignalRConnection';
export const SET_SIGNALR_CONNECTION_ID = 'setSignalRConnectionId';

const setSignalRConnection = (state, payload) => {
    state.connection = payload;
};

const setSignalRConnectionId = (state, payload) => {
    state.connectionId = payload;
};

export default {
    setSignalRConnection,
    setSignalRConnectionId
};
